<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            :before-close="close"
            :close-on-click-modal="false"
            title="Đặt lại mật khẩu"
            custom-class="popup-register"
            top="20vh"
            append-to-body
            destroy-on-close
        >
            <LoadingForm :loading="loading" />
            <div class="bg-[#FFFFFF] rounded-lg p-3">
                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                >
                    <div class=" mb-6 ">
                        <el-form-item class="mb-3 label-input-login" label="Mật khẩu mới" prop="newPassword">
                            <el-input
                                v-model="form.newPassword"
                                class="input-login"
                                prefix-icon="el-icon-lock"
                                :type="showPassword ? 'text' : 'password'"
                            >
                                <template #suffix>
                                    <i class="el-input__icon el-icon-view font-bold" :class="{ 'text-[#C0C4CC]': !showPassword, 'text-[#292929]': showPassword }" @click="toggleShowPassword" />
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="mb-6 label-input-login" label="Nhập lại mật khẩu" prop="confirmPassword">
                            <el-input
                                v-model="form.confirmPassword"
                                class="input-login"
                                prefix-icon="el-icon-lock"
                                :type="showConfirmPassword ? 'text' : 'password'"
                            >
                                <template #suffix>
                                    <i class="el-input__icon el-icon-view font-bold" :class="{ 'text-[#C0C4CC]': !showConfirmPassword, 'text-[#292929]': showConfirmPassword }" @click="toggleShowConfirmPassword" />
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-button class="w-full bg-[#008A07] text-[#FFFFFF] text-sm rounded-lg" @click="handleRegister">
                            Xác nhận
                        </el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import { confirmPassValidator } from '../../utils/form';
    import LoadingForm from './LoadingForm.vue';

    export default {
        components: {
            LoadingForm,
        },
        data() {
            return {
                dialogVisible: true,
                showPassword: false,
                showConfirmPassword: false,
                loading: false,
                form: {
                    newPassword: '',
                    confirmPassword: '',
                },
                rules: {
                    newPassword: [
                        { required: true, message: 'Vui lòng nhập mật khẩu', trigger: 'change' },
                        {
                            min: 6, max: 20, message: 'Độ dài mật khẩu phải từ 6 đến 20 kí tự', trigger: 'change',
                        },
                    ],
                    confirmPassword: [
                        { required: true, message: 'Xác nhận mật khẩu không khớp', trigger: 'change' },
                        { validator: (rule, value, callback) => confirmPassValidator(this.form.newPassword)(rule, value, callback), trigger: 'change' },
                    ],
                },
            };
        },
        computed: {
            ...mapState('auth', ['data', 'tokenForgotPass']),
        },
        methods: {
            close() {
                this.dialogVisible = false;
                this.$emit('newPassPopup', false);
            },
            toggleShowPassword() {
                this.showPassword = !this.showPassword;
            },
            toggleShowConfirmPassword() {
                this.showConfirmPassword = !this.showConfirmPassword;
            },
            handleRegister() {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        this.$store.dispatch('auth/setShowNav', true);
                        this.loading = true;
                        this.$apiPortal.auth.updateNewPass({ token: this.tokenForgotPass, newPassword: this.form.newPassword }).then(async () => {
                            this.dialogVisible = false;
                            this.loading = false;
                            this.$emit('newPassPopup', false);
                            await this.$auth.loginWith('cookie', {
                                data: {
                                    phoneNumber: this.data.phoneNumber,
                                    password: this.form.newPassword,
                                },
                            });
                        })
                            .catch((e) => {
                                if (e.response) {
                                    this.loading = false;
                                    return this.$message({
                                        message: e.response.data.message,
                                        type: 'error',
                                        duration: 1500,
                                    });
                                }
                            });
                    }
                });
            },
            handleLogin() {
                this.$emit('registerPopup', false);
                this.$emit('loginPopup', true);
            },
        },
    };
</script>
<style lang="scss">
 .el-dialog {
    max-width: 1200px;
    border-radius: 15px;
    width: 95vw !important;
}
.input-login {
        .el-input__inner {
            border: 1px solid #292929 !important;
        }
    }
.label-input-login {
.el-form-item__label{
    color: #292929;
}
    }
    .popup-register{
        .el-dialog__header{
            padding: 20px 20px 0px;
        }
        .el-dialog__title{
            color: #003A03;
            font-size: 20px;
            font-weight: 500;
        }
        .el-dialog__headerbtn .el-dialog__close {
            color: #292929;
            font-size: 18px;

        }
    }
</style>
